<template>
  <div
    ref="kt_modal_faturamento_editar_nfe_produto"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_faturamento_editar_nfe_produto"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header py-3">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen005.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Editar</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="d-flex flex-column flex-md-row rounded">
            <div class="d-grid">
              <ul
                class="nav nav-tabs nav-pills border-0 flex-row flex-md-column me-5 mb-3 mb-md-0 fs-6 min-w-lg-200px"
              >
                <li class="nav-item w-md-200px me-0">
                  <a
                    ref="tabImpostos"
                    id="tabImpostos"
                    class="nav-link btn btn-flex w-100 btn-active-light btn-color-gray-600 btn-active-color-primary rounded active nav-link-faturamento-prod"
                    data-bs-toggle="tab"
                    href="#kt_faturamento_nfe_produtos_impostos"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/ecommerce/ecm011.svg"
                        class="me-2"
                      />
                    </span>
                    Impostos</a
                  >
                </li>
                <li class="nav-item w-md-200px me-0">
                  <a
                    ref="tabUnidadeTributavel"
                    id="tabUnidadeTributavel"
                    class="nav-link btn btn-flex w-100 btn-active-light btn-color-gray-600 btn-active-color-primary roundednav-link-faturamento-prod"
                    data-bs-toggle="tab"
                    href="#kt_faturamento_nfe_produtos_und_trib"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/general/gen028.svg"
                        class="me-2"
                      />
                    </span>
                    Unidade Tributável</a
                  >
                </li>
                <li class="nav-item w-md-200px me-0">
                  <a
                    ref="tabImportacao"
                    id="tabImportacao"
                    class="nav-link btn btn-flex w-100 btn-active-light btn-color-gray-600 btn-active-color-primary roundednav-link-faturamento-prod"
                    data-bs-toggle="tab"
                    href="#kt_faturamento_nfe_produtos_importacao"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/arrows/arr037.svg"
                        class="me-2"
                      />
                    </span>
                    Importação</a
                  >
                </li>
                <li class="nav-item w-md-200px me-0">
                  <a
                    ref="tabExportacao"
                    id="tabExportacao"
                    class="nav-link btn btn-flex w-100 btn-active-light btn-color-gray-600 btn-active-color-primary roundednav-link-faturamento-prod"
                    data-bs-toggle="tab"
                    href="#kt_faturamento_nfe_produtos_exportacao"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/arrows/arr036.svg"
                        class="me-2" /></span
                    >Exportação</a
                  >
                </li>
                <li class="nav-item w-md-200px me-0">
                  <a
                    ref="tabPedidoCompra"
                    id="tabPedidoCompra"
                    class="nav-link btn btn-flex w-100 btn-active-light btn-color-gray-600 btn-active-color-primary roundednav-link-faturamento-prod"
                    data-bs-toggle="tab"
                    href="#kt_faturamento_nfe_produtos_pedido_compra"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/general/gen005.svg"
                        class="me-2" /></span
                    >Pedido de Compra</a
                  >
                </li>
                <li class="nav-item w-md-200px me-0">
                  <a
                    ref="tabVeiculo"
                    id="tabVeiculo"
                    class="nav-link btn btn-flex w-100 btn-active-light btn-color-gray-600 btn-active-color-primary roundednav-link-faturamento-prod"
                    data-bs-toggle="tab"
                    href="#kt_faturamento_nfe_produtos_veiculo"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/abstract/abs021.svg"
                        class="me-2"
                    /></span>
                    Veículo</a
                  >
                </li>
                <li class="nav-item w-md-200px me-0">
                  <a
                    ref="tabMedicamento"
                    id="tabMedicamento"
                    class="nav-link btn btn-flex w-100 btn-active-light btn-color-gray-600 btn-active-color-primary roundednav-link-faturamento-prod"
                    data-bs-toggle="tab"
                    href="#kt_faturamento_nfe_produtos_medicamento"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/medicine/med002.svg"
                        class="me-2"
                    /></span>
                    Medicamento</a
                  >
                </li>
                <li class="nav-item w-md-200px me-0">
                  <a
                    ref="tabCombustivel"
                    id="tabCombustivel"
                    class="nav-link btn btn-flex w-100 btn-active-light btn-color-gray-600 btn-active-color-primary roundednav-link-faturamento-prod"
                    data-bs-toggle="tab"
                    href="#kt_faturamento_nfe_produtos_combustivel"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/medicine/med005.svg"
                        class="me-2"
                    /></span>
                    Combustível</a
                  >
                </li>
              </ul>
            </div>
            <div class="tab-content d-flex flex-column flex-row-fluid">
              <div
                class="tab-pane fade show active tab-pane-faturamento-prod"
                id="kt_faturamento_nfe_produtos_impostos"
                role="tab-panel"
              >
                <div class="d-flex flex-column gap-7 gap-lg-10 mb-5 mx-5">
                  <div class="card card-bordered">
                    <div class="card-header bg-light min-h-50px">
                      <div class="card-title">
                        <h3>Tabela de Estados</h3>
                      </div>
                    </div>
                    <div class="card-body pt-4 pb-2">
                      <label class="form-label">Tabela selecionada</label>
                      <div class="input-group mb-0">
                        <input
                          id="txtTabelaEstados"
                          type="text"
                          class="form-control"
                          :value="
                            this.nfe.FaturamentoItemNFe &&
                            this.nfe.FaturamentoItemNFe.id_estoque_st &&
                            this.nfe.FaturamentoItemNFe.id_estoque_st > 0 &&
                            this.nfe.FaturamentoItemNFe.EstoqueSt &&
                            this.nfe.FaturamentoItemNFe.EstoqueSt !== null
                              ? this.nfe.FaturamentoItemNFe.EstoqueSt.id +
                                ' - ' +
                                this.nfe.FaturamentoItemNFe.EstoqueSt.descricao
                              : ''
                          "
                          readonly
                        />
                        <span
                          type="button"
                          class="svg-icon svg-icon-1 position-absolute end-0 me-18 mt-3"
                          @click="limparTabelaEstados()"
                        >
                          <inline-svg
                            src="media/icons/duotune/arrows/arr061.svg"
                          />
                        </span>
                        <button
                          type="button"
                          class="input-group-text"
                          @click="this.modalTabelaEstados(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["id_estoque_st"] }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column gap-7 gap-lg-10 mb-5 mx-5">
                  <div class="card card-bordered">
                    <div class="card-header bg-light min-h-50px">
                      <div class="card-title">
                        <h3>PIS/COFINS</h3>
                      </div>
                    </div>
                    <div class="card-body pt-4 pb-0">
                      <div class="row">
                        <div
                          class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 fv-row mb-6"
                        >
                          <label
                            class="form-check form-switch form-switch-sm form-check-custom form-check-solid"
                          >
                            <input
                              class="form-check-input ms-0"
                              type="checkbox"
                              value=""
                              v-model="
                                this.nfe.FaturamentoItemNFe.utiliza_pis_cofins
                              "
                            />
                            <span
                              class="form-check-label ms-5 fw-bolder fs-6 text-gray-700"
                              >Utilizar PIS/COFINS selecionados nesta
                              tela.</span
                            >
                          </label>
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
                        >
                          <label class="form-label">PIS ST</label>
                          <select
                            class="form-select"
                            data-control="select2"
                            data-hide-search="true"
                            data-placeholder="Selecione uma opção"
                            v-model="this.nfe.FaturamentoItemNFe.pis_st"
                          >
                            <option value="01">
                              01 - Operação Tributável com Alíquota Básica
                            </option>
                            <option value="02">
                              02 - Operação Tributável com Alíquota Diferenciada
                            </option>
                            <option value="03">
                              03 - Operação Tributável com Alíquota por Unidade
                              de Medida de Produto
                            </option>
                            <option value="04">
                              04 - Operação Tributável Monofásica - Revenda a
                              Alíquota Zero
                            </option>
                            <option value="05">
                              05 - Operação Tributável por Substituição
                              Tributária
                            </option>
                            <option value="06">
                              06 - Operação Tributável a Alíquota Zero
                            </option>
                            <option value="07">
                              07 - Operação Isenta da Contribuição
                            </option>
                            <option value="08">
                              08 - Operação sem Incidência da Contribuição
                            </option>
                            <option value="09">
                              09 - Operação com Suspensão da Contribuição
                            </option>
                            <option value="49" selected="selected">
                              49 - Outras Operações de Saída
                            </option>
                            <option value="50">
                              50 - Operação com Direito a Crédito - Vinculada
                              Exclusivamente a Receita Tributada no Mercado
                              Interno
                            </option>
                            <option value="51">
                              51 - Operação com Direito a Crédito – Vinculada
                              Exclusivamente a Receita Não Tributada no Mercado
                              Interno
                            </option>
                            <option value="52">
                              52 - Operação com Direito a Crédito - Vinculada
                              Exclusivamente a Receita de Exportação
                            </option>
                            <option value="53">
                              53 - Operação com Direito a Crédito - Vinculada a
                              Receitas Tributadas e Não-Tributadas no Mercado
                              Interno
                            </option>
                            <option value="54">
                              54 - Operação com Direito a Crédito - Vinculada a
                              Receitas Tributadas no Mercado Interno e de
                              Exportação
                            </option>
                            <option value="55">
                              55 - Operação com Direito a Crédito - Vinculada a
                              Receitas Não-Tributadas no Mercado Interno e de
                              Exportação
                            </option>
                            <option value="56">
                              56 - Operação com Direito a Crédito - Vinculada a
                              Receitas Tributadas e Não-Tributadas no Mercado
                              Interno, e de Exportação
                            </option>
                            <option value="60">
                              60 - Crédito Presumido - Operação de Aquisição
                              Vinculada Exclusivamente a Receita Tributada no
                              Mercado Interno
                            </option>
                            <option value="61">
                              61 - Crédito Presumido - Operação de Aquisição
                              Vinculada Exclusivamente a Receita Não-Tributada
                              no Mercado Interno
                            </option>
                            <option value="62">
                              62 - Crédito Presumido - Operação de Aquisição
                              Vinculada Exclusivamente a Receita de Exportação
                            </option>
                            <option value="63">
                              63 - Crédito Presumido - Operação de Aquisição
                              Vinculada a Receitas Tributadas e Não-Tributadas
                              no Mercado Interno
                            </option>
                            <option value="64">
                              64 - Crédito Presumido - Operação de Aquisição
                              Vinculada a Receitas Tributadas no Mercado Interno
                              e de Exportação
                            </option>
                            <option value="65">
                              65 - Crédito Presumido - Operação de Aquisição
                              Vinculada a Receitas Não-Tributadas no Mercado
                              Interno e de Exportação
                            </option>
                            <option value="66">
                              66 - Crédito Presumido - Operação de Aquisição
                              Vinculada a Receitas Tributadas e Não-Tributadas
                              no Mercado Interno, e de Exportação
                            </option>
                            <option value="67">
                              67 - Crédito Presumido - Outras Operações
                            </option>
                            <option value="70">
                              70 - Operação de Aquisição sem Direito a Crédito
                            </option>
                            <option value="71">
                              71 - Operação de Aquisição com Isenção
                            </option>
                            <option value="72">
                              72 - Operação de Aquisição com Suspensão
                            </option>
                            <option value="73">
                              73 - Operação de Aquisição a Alíquota Zero
                            </option>
                            <option value="74">
                              74 - Operação de Aquisição sem Incidência da
                              Contribuição
                            </option>
                            <option value="75">
                              75 - Operação de Aquisição por Substituição
                              Tributária
                            </option>
                            <option value="98">
                              98 - Outras Operações de Entrada
                            </option>
                            <option value="99">99 - Outras Operações</option>
                          </select>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["pis_st"] }}
                          </div>
                        </div>
                        <div
                          class="col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-3 fv-row mb-6"
                        >
                          <label class="form-label">PIS Base</label>
                          <CurrencyInput
                            class="form-control mb-2 text-danger"
                            placeholder="PIS Base"
                            style="text-align: right"
                            v-model="this.nfe.FaturamentoItemNFe.pis_base"
                            :options="options"
                          ></CurrencyInput>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["pis_base"] }}
                          </div>
                        </div>
                        <div
                          class="col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-3 fv-row mb-6"
                        >
                          <label class="form-label">PIS Alíquota</label>
                          <CurrencyInput
                            class="form-control mb-2 text-danger"
                            placeholder="PIS Alíquota"
                            style="text-align: right"
                            v-model="this.nfe.FaturamentoItemNFe.pis_aliquota"
                            :options="options"
                          ></CurrencyInput>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["pis_aliquota"] }}
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
                        >
                          <label class="form-label">COFINS ST</label>
                          <select
                            class="form-select"
                            data-control="select2"
                            data-hide-search="true"
                            data-placeholder="Selecione uma opção"
                            v-model="this.nfe.FaturamentoItemNFe.cofins_st"
                          >
                            <option value="01">
                              01 - Operação Tributável com Alíquota Básica
                            </option>
                            <option value="02">
                              02 - Operação Tributável com Alíquota Diferenciada
                            </option>
                            <option value="03">
                              03 - Operação Tributável com Alíquota por Unidade
                              de Medida de Produto
                            </option>
                            <option value="04">
                              04 - Operação Tributável Monofásica - Revenda a
                              Alíquota Zero
                            </option>
                            <option value="05">
                              05 - Operação Tributável por Substituição
                              Tributária
                            </option>
                            <option value="06">
                              06 - Operação Tributável a Alíquota Zero
                            </option>
                            <option value="07">
                              07 - Operação Isenta da Contribuição
                            </option>
                            <option value="08">
                              08 - Operação sem Incidência da Contribuição
                            </option>
                            <option value="09">
                              09 - Operação com Suspensão da Contribuição
                            </option>
                            <option value="49" selected="selected">
                              49 - Outras Operações de Saída
                            </option>
                            <option value="50">
                              50 - Operação com Direito a Crédito - Vinculada
                              Exclusivamente a Receita Tributada no Mercado
                              Interno
                            </option>
                            <option value="51">
                              51 - Operação com Direito a Crédito – Vinculada
                              Exclusivamente a Receita Não Tributada no Mercado
                              Interno
                            </option>
                            <option value="52">
                              52 - Operação com Direito a Crédito - Vinculada
                              Exclusivamente a Receita de Exportação
                            </option>
                            <option value="53">
                              53 - Operação com Direito a Crédito - Vinculada a
                              Receitas Tributadas e Não-Tributadas no Mercado
                              Interno
                            </option>
                            <option value="54">
                              54 - Operação com Direito a Crédito - Vinculada a
                              Receitas Tributadas no Mercado Interno e de
                              Exportação
                            </option>
                            <option value="55">
                              55 - Operação com Direito a Crédito - Vinculada a
                              Receitas Não-Tributadas no Mercado Interno e de
                              Exportação
                            </option>
                            <option value="56">
                              56 - Operação com Direito a Crédito - Vinculada a
                              Receitas Tributadas e Não-Tributadas no Mercado
                              Interno, e de Exportação
                            </option>
                            <option value="60">
                              60 - Crédito Presumido - Operação de Aquisição
                              Vinculada Exclusivamente a Receita Tributada no
                              Mercado Interno
                            </option>
                            <option value="61">
                              61 - Crédito Presumido - Operação de Aquisição
                              Vinculada Exclusivamente a Receita Não-Tributada
                              no Mercado Interno
                            </option>
                            <option value="62">
                              62 - Crédito Presumido - Operação de Aquisição
                              Vinculada Exclusivamente a Receita de Exportação
                            </option>
                            <option value="63">
                              63 - Crédito Presumido - Operação de Aquisição
                              Vinculada a Receitas Tributadas e Não-Tributadas
                              no Mercado Interno
                            </option>
                            <option value="64">
                              64 - Crédito Presumido - Operação de Aquisição
                              Vinculada a Receitas Tributadas no Mercado Interno
                              e de Exportação
                            </option>
                            <option value="65">
                              65 - Crédito Presumido - Operação de Aquisição
                              Vinculada a Receitas Não-Tributadas no Mercado
                              Interno e de Exportação
                            </option>
                            <option value="66">
                              66 - Crédito Presumido - Operação de Aquisição
                              Vinculada a Receitas Tributadas e Não-Tributadas
                              no Mercado Interno, e de Exportação
                            </option>
                            <option value="67">
                              67 - Crédito Presumido - Outras Operações
                            </option>
                            <option value="70">
                              70 - Operação de Aquisição sem Direito a Crédito
                            </option>
                            <option value="71">
                              71 - Operação de Aquisição com Isenção
                            </option>
                            <option value="72">
                              72 - Operação de Aquisição com Suspensão
                            </option>
                            <option value="73">
                              73 - Operação de Aquisição a Alíquota Zero
                            </option>
                            <option value="74">
                              74 - Operação de Aquisição sem Incidência da
                              Contribuição
                            </option>
                            <option value="75">
                              75 - Operação de Aquisição por Substituição
                              Tributária
                            </option>
                            <option value="98">
                              98 - Outras Operações de Entrada
                            </option>
                            <option value="99">99 - Outras Operações</option>
                          </select>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["cofins_st"] }}
                          </div>
                        </div>
                        <div
                          class="col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-3 fv-row mb-6"
                        >
                          <label class="form-label">COFINS Base</label>
                          <CurrencyInput
                            class="form-control mb-2 text-danger"
                            placeholder="COFINS Base"
                            style="text-align: right"
                            v-model="this.nfe.FaturamentoItemNFe.cofins_base"
                            :options="options"
                          ></CurrencyInput>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["cofins_base"] }}
                          </div>
                        </div>
                        <div
                          class="col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-3 fv-row mb-6"
                        >
                          <label class="form-label">COFINS Alíquota</label>
                          <CurrencyInput
                            class="form-control mb-2 text-danger"
                            placeholder="COFINS Alíquota"
                            style="text-align: right"
                            v-model="
                              this.nfe.FaturamentoItemNFe.cofins_aliquota
                            "
                            :options="options"
                          ></CurrencyInput>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["cofins_aliquota"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column gap-7 gap-lg-10 mb-5 mx-5">
                  <div class="card card-bordered">
                    <div class="card-header bg-light min-h-50px">
                      <div class="card-title">
                        <h3>IPI</h3>
                      </div>
                    </div>
                    <div class="card-body pt-4 pb-0">
                      <div class="row">
                        <div
                          class="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-8 fv-row mb-6"
                        >
                          <label class="form-label">CST IPI</label>
                          <select
                            class="form-select"
                            data-control="select2"
                            data-hide-search="true"
                            data-placeholder="Selecione uma opção"
                            v-model="this.nfe.FaturamentoItemNFe.cst_ipi"
                          >
                            <option value="00">
                              00 - Entrada com recuperação de crédito
                            </option>
                            <option value="01">
                              01 - Entrada tributada com alíquota zero
                            </option>
                            <option value="02">02 - Entrada isenta</option>
                            <option value="03">
                              03 - Entrada não-tributada
                            </option>
                            <option value="04">04 - Entrada imune</option>
                            <option value="05">
                              05 - Entrada com suspensão
                            </option>
                            <option value="49">49 - Outras entradas</option>
                            <option value="50">50 - Saída tributada</option>
                            <option value="51">
                              51 - Saída tributada com alíquota zero
                            </option>
                            <option value="52">52 - Saída isenta</option>
                            <option value="53">53 - Saída não-tributada</option>
                            <option value="54">54 - Saída imune</option>
                            <option value="55">55 - Saída com suspensão</option>
                            <option value="99">99 - Outras saídas</option>
                          </select>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["cst_ipi"] }}
                          </div>
                        </div>
                        <div
                          class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
                        >
                          <label class="form-label">IPI Devolvido</label>
                          <CurrencyInput
                            class="form-control mb-2 text-danger"
                            placeholder="IPI Devolvido"
                            style="text-align: right"
                            v-model="this.nfe.FaturamentoItemNFe.ipi_devolvido"
                            :options="options"
                          ></CurrencyInput>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["ipi_devolvido"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column gap-7 gap-lg-10 mb-5 mx-5">
                  <div class="card card-bordered">
                    <div class="card-header bg-light min-h-50px">
                      <div class="card-title">
                        <h3>ICMS</h3>
                      </div>
                    </div>
                    <div class="card-body pt-4 pb-0">
                      <div class="row">
                        <div
                          class="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-8 fv-row mb-6"
                        >
                          <label class="form-label"
                            >Tipo Desoneração ICMS</label
                          >
                          <select
                            class="form-select"
                            data-control="select2"
                            data-hide-search="true"
                            data-placeholder="Selecione uma opção"
                            v-model="
                              this.nfe.FaturamentoItemNFe.tipo_desoneracao
                            "
                          >
                            <option value="1">1 - Táxi</option>
                            <option value="3">3 - Produtor Agropecuário</option>
                            <option value="4">4 - Frotista/Locadora</option>
                            <option value="5">5 - Diplomático/Consular</option>
                            <option value="6">
                              6 - Utilitários e Motocicletas da Amazônia
                              Ocidental e Áreas de Livre Comércio (Resolução
                              714/88 e 790/94 – CONTRAN e suas alterações)
                            </option>
                            <option value="7">7 - SUFRAMA</option>
                            <option value="8">8 - Venda a Órgão Público</option>
                            <option value="9" selected="selected">
                              9 - Outros. (NT 2011/004)
                            </option>
                            <option value="10">
                              10 - Deficiente Condutor (Convênio ICMS 38/12)
                            </option>
                            <option value="11">
                              11 - Deficiente Não Condutor (Convênio ICMS 38/12)
                            </option>
                          </select>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["tipo_desoneracao"] }}
                          </div>
                        </div>
                        <div
                          class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
                        >
                          <label class="form-label">ICMS Desonerado</label>
                          <CurrencyInput
                            class="form-control mb-2 text-danger"
                            placeholder="ICMS Desonerado"
                            style="text-align: right"
                            v-model="
                              this.nfe.FaturamentoItemNFe.icms_desonerado
                            "
                            :options="options"
                          ></CurrencyInput>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["icms_desonerado"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column gap-7 gap-lg-10 mb-5 mx-5">
                  <div class="card card-bordered">
                    <div class="card-header bg-light min-h-50px">
                      <div class="card-title">
                        <h3>FCP - Fundo de Combate à Pobreza</h3>
                      </div>
                    </div>
                    <div class="card-body pt-4 pb-0">
                      <div class="row">
                        <div
                          class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
                        >
                          <label class="form-label">Alíquota FCP</label>
                          <CurrencyInput
                            class="form-control mb-2 text-danger"
                            placeholder="Alíquota FCP"
                            style="text-align: right"
                            v-model="this.nfe.FaturamentoItemNFe.aliquota_fcp"
                            :options="options"
                          ></CurrencyInput>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["aliquota_fcp"] }}
                          </div>
                        </div>
                        <div
                          class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
                        >
                          <label class="form-label">Alíquota FCP ST</label>
                          <CurrencyInput
                            class="form-control mb-2 text-danger"
                            placeholder="Alíquota FCP ST"
                            style="text-align: right"
                            v-model="
                              this.nfe.FaturamentoItemNFe.aliquota_fcp_st
                            "
                            :options="options"
                          ></CurrencyInput>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["aliquota_fcp_st"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade tab-pane-faturamento-prod"
                id="kt_faturamento_nfe_produtos_und_trib"
                role="tab-panel"
              >
                <div class="d-flex flex-column gap-7 gap-lg-10 mb-5 mx-5">
                  <div class="card card-bordered">
                    <div class="card-header bg-light min-h-50px">
                      <div class="card-title">
                        <h3>Unidade Tributável</h3>
                      </div>
                      <div class="card-toolbar">
                        <div
                          class="d-flex justify-content-end"
                          data-kt-customer-table-toolbar="base"
                        >
                          <button
                            @click="adicionarFaturamentoUnidadeTributavel()"
                            type="button"
                            class="btn btn-sm btn-primary btn-active-primary"
                          >
                            <span class="svg-icon svg-icon-1">
                              <inline-svg
                                src="media/icons/duotune/arrows/arr075.svg" /></span
                            >Adicionar
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-2 pb-2">
                      <div class="table-responsive">
                        <table
                          :class="[loadingUndTrib && 'overlay overlay-block']"
                          class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                          id="kt_table_und_trib"
                        >
                          <thead>
                            <tr class="fw-bolder text-muted">
                              <th>UND</th>
                              <th>Qtd. Trib.</th>
                              <th>Vl. Unit. Trib.</th>
                              <th class="min-w-100px text-end">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-if="
                                this.nfe.FaturamentoItemNFe.und_trib.length > 0
                              "
                            >
                              <template
                                v-for="(und, i) in this.nfe.FaturamentoItemNFe
                                  .und_trib"
                                :key="i"
                              >
                                <tr>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ und.uTrib }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarNumeroCasas(
                                              und.qTrib,
                                              4
                                            )
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarNumeroCasas(
                                              und.vUnTrib,
                                              10
                                            )
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    class="d-flex justify-content-end flex-shrink-0"
                                  >
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                      @click="
                                        editarFaturamentoUnidadeTributavel(i)
                                      "
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/art/art005.svg"
                                        />
                                      </span>
                                    </button>
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                      @click="
                                        removerFaturamentoUnidadeTributavel(i)
                                      "
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/general/gen027.svg"
                                        />
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              </template>
                            </template>
                            <template v-else>
                              <tr class="odd">
                                <td :colSpan="12" class="dataTables_empty">
                                  {{ "Sem registros" }}
                                </td>
                              </tr>
                            </template>
                          </tbody>
                          <div
                            v-if="loadingUndTrib"
                            class="overlay-layer card-rounded bg-dark bg-opacity-5"
                          >
                            <div
                              class="spinner-border text-primary"
                              role="status"
                            ></div>
                            <span class="ms-2">Aguarde, carregando...</span>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade tab-pane-faturamento-prod"
                id="kt_faturamento_nfe_produtos_importacao"
                role="tab-panel"
              >
                <div class="d-flex flex-column gap-7 gap-lg-10 mb-5 mx-5">
                  <div class="card card-bordered">
                    <div class="card-header bg-light min-h-50px">
                      <div class="card-title">
                        <h3>Imposto de Importação (II)</h3>
                      </div>
                      <div class="card-toolbar">
                        <div
                          class="d-flex justify-content-end"
                          data-kt-customer-table-toolbar="base"
                        >
                          <button
                            @click="adicionarFaturamentoImpostoImportacao()"
                            type="button"
                            class="btn btn-sm btn-primary btn-active-primary"
                          >
                            <span class="svg-icon svg-icon-1">
                              <inline-svg
                                src="media/icons/duotune/arrows/arr075.svg" /></span
                            >Adicionar
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-2 pb-2">
                      <div class="table-responsive">
                        <table
                          :class="[
                            loadingImpostoImportacao && 'overlay overlay-block',
                          ]"
                          class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                          id="kt_table_imposto_importacao"
                        >
                          <thead>
                            <tr class="fw-bolder text-muted">
                              <th>Base Cálculo Imposto</th>
                              <th>Valor despesas</th>
                              <th>Valor Imposto</th>
                              <th>Valor IOF</th>
                              <th class="min-w-100px text-end">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-if="
                                this.nfe.FaturamentoItemNFe.imposto_importacao
                                  .length > 0
                              "
                            >
                              <template
                                v-for="(imp, i) in this.nfe.FaturamentoItemNFe
                                  .imposto_importacao"
                                :key="i"
                              >
                                <tr>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarNumeroCasas(
                                              imp.vBC,
                                              2
                                            )
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarNumeroCasas(
                                              imp.vDespAdu,
                                              2
                                            )
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarNumeroCasas(
                                              imp.vII,
                                              2
                                            )
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarNumeroCasas(
                                              imp.vIOF,
                                              2
                                            )
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    class="d-flex justify-content-end flex-shrink-0"
                                  >
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                      @click="
                                        editarFaturamentoImpostoImportacao(i)
                                      "
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/art/art005.svg"
                                        />
                                      </span>
                                    </button>
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                      @click="
                                        removerFaturamentoImpostoImportacao(i)
                                      "
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/general/gen027.svg"
                                        />
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              </template>
                            </template>
                            <template v-else>
                              <tr class="odd">
                                <td :colSpan="12" class="dataTables_empty">
                                  {{ "Sem registros" }}
                                </td>
                              </tr>
                            </template>
                          </tbody>
                          <div
                            v-if="loadingImpostoImportacao"
                            class="overlay-layer card-rounded bg-dark bg-opacity-5"
                          >
                            <div
                              class="spinner-border text-primary"
                              role="status"
                            ></div>
                            <span class="ms-2">Aguarde, carregando...</span>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column gap-7 gap-lg-10 mb-5 mx-5">
                  <div class="card card-bordered">
                    <div class="card-header bg-light min-h-50px">
                      <div class="card-title">
                        <h3>Declaração de Importação (DI)</h3>
                      </div>
                      <div class="card-toolbar">
                        <div
                          class="d-flex justify-content-end"
                          data-kt-customer-table-toolbar="base"
                        >
                          <button
                            @click="adicionarFaturamentoDeclaracaoImportacao()"
                            type="button"
                            class="btn btn-sm btn-primary btn-active-primary"
                          >
                            <span class="svg-icon svg-icon-1">
                              <inline-svg
                                src="media/icons/duotune/arrows/arr075.svg" /></span
                            >Adicionar
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-2 pb-2">
                      <div class="table-responsive">
                        <table
                          :class="[
                            loadingDeclaracaoImportacao &&
                              'overlay overlay-block',
                          ]"
                          class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                          id="kt_table_declaracao_importacao"
                        >
                          <thead>
                            <tr class="fw-bolder text-muted">
                              <th>Nº Documento</th>
                              <th>Data Registro</th>
                              <th>Local de Desembaraço</th>
                              <th>UF Desembaraço</th>
                              <th>Data Desembaraço</th>
                              <th>Valor da AFRMM</th>
                              <th>Código do exportador</th>
                              <th class="min-w-100px text-end">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-if="
                                this.nfe.FaturamentoItemNFe
                                  .declaracao_importacao.length > 0
                              "
                            >
                              <template
                                v-for="(imp, i) in this.nfe.FaturamentoItemNFe
                                  .declaracao_importacao"
                                :key="i"
                              >
                                <tr>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ imp.nDI }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarData(imp.dDI)
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ imp.xLocDesemb }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ imp.UFDesemb }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarData(
                                              imp.dDesemb
                                            )
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarNumeroCasas(
                                              imp.vAFRMM,
                                              2
                                            )
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ imp.cExportador }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    class="d-flex justify-content-end flex-shrink-0"
                                  >
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                      @click="
                                        editarFaturamentoDeclaracaoImportacao(i)
                                      "
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/art/art005.svg"
                                        />
                                      </span>
                                    </button>
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                      @click="
                                        removerFaturamentoDeclaracaoImportacao(
                                          i
                                        )
                                      "
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/general/gen027.svg"
                                        />
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              </template>
                            </template>
                            <template v-else>
                              <tr class="odd">
                                <td :colSpan="12" class="dataTables_empty">
                                  {{ "Sem registros" }}
                                </td>
                              </tr>
                            </template>
                          </tbody>
                          <div
                            v-if="loadingDeclaracaoImportacao"
                            class="overlay-layer card-rounded bg-dark bg-opacity-5"
                          >
                            <div
                              class="spinner-border text-primary"
                              role="status"
                            ></div>
                            <span class="ms-2">Aguarde, carregando...</span>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column gap-7 gap-lg-10 mb-5 mx-5">
                  <div class="card card-bordered">
                    <div class="card-header bg-light min-h-50px">
                      <div class="card-title">
                        <h3>FCI - Ficha de Conteúdo de Importação</h3>
                      </div>
                      <div class="card-toolbar">
                        <div
                          class="d-flex justify-content-end"
                          data-kt-customer-table-toolbar="base"
                        >
                          <button
                            @click="adicionarFaturamentoFCI()"
                            type="button"
                            class="btn btn-sm btn-primary btn-active-primary"
                          >
                            <span class="svg-icon svg-icon-1">
                              <inline-svg
                                src="media/icons/duotune/arrows/arr075.svg" /></span
                            >Adicionar
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-2 pb-2">
                      <div class="table-responsive">
                        <table
                          :class="[loadingFCI && 'overlay overlay-block']"
                          class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                          id="kt_table_fci"
                        >
                          <thead>
                            <tr class="fw-bolder text-muted">
                              <th>Nº FCI</th>
                              <th class="min-w-100px text-end">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-if="this.nfe.FaturamentoItemNFe.fci.length > 0"
                            >
                              <template
                                v-for="(imp, i) in this.nfe.FaturamentoItemNFe
                                  .fci"
                                :key="i"
                              >
                                <tr>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ imp.nFCI }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    class="d-flex justify-content-end flex-shrink-0"
                                  >
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                      @click="editarFaturamentoFCI(i)"
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/art/art005.svg"
                                        />
                                      </span>
                                    </button>
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                      @click="removerFaturamentoFCI(i)"
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/general/gen027.svg"
                                        />
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              </template>
                            </template>
                            <template v-else>
                              <tr class="odd">
                                <td :colSpan="12" class="dataTables_empty">
                                  {{ "Sem registros" }}
                                </td>
                              </tr>
                            </template>
                          </tbody>
                          <div
                            v-if="loadingFCI"
                            class="overlay-layer card-rounded bg-dark bg-opacity-5"
                          >
                            <div
                              class="spinner-border text-primary"
                              role="status"
                            ></div>
                            <span class="ms-2">Aguarde, carregando...</span>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade tab-pane-faturamento-prod"
                id="kt_faturamento_nfe_produtos_exportacao"
                role="tab-panel"
              >
                <div class="d-flex flex-column gap-7 gap-lg-10 mb-5 mx-5">
                  <div class="card card-bordered">
                    <div class="card-header bg-light min-h-50px">
                      <div class="card-title">
                        <h3>Exportação</h3>
                      </div>
                      <div class="card-toolbar">
                        <div
                          class="d-flex justify-content-end"
                          data-kt-customer-table-toolbar="base"
                        >
                          <button
                            @click="adicionarFaturamentoExportacao()"
                            type="button"
                            class="btn btn-sm btn-primary btn-active-primary"
                          >
                            <span class="svg-icon svg-icon-1">
                              <inline-svg
                                src="media/icons/duotune/arrows/arr075.svg" /></span
                            >Adicionar
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-2 pb-2">
                      <div class="table-responsive">
                        <table
                          :class="[
                            loadingExportacao && 'overlay overlay-block',
                          ]"
                          class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                          id="kt_table_exportacao"
                        >
                          <thead>
                            <tr class="fw-bolder text-muted">
                              <th>Item</th>
                              <th>Nº Drawback</th>
                              <th class="min-w-100px text-end">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-if="
                                this.nfe.FaturamentoItemNFe.det_export.length >
                                0
                              "
                            >
                              <template
                                v-for="(exp, i) in this.nfe.FaturamentoItemNFe
                                  .det_export"
                                :key="i"
                              >
                                <tr>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ i + 1 }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ exp.nDraw }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    class="d-flex justify-content-end flex-shrink-0"
                                  >
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                      @click="editarFaturamentoExportacao(i)"
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/art/art005.svg"
                                        />
                                      </span>
                                    </button>
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                      @click="removerFaturamentoExportacao(i)"
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/general/gen027.svg"
                                        />
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              </template>
                            </template>
                            <template v-else>
                              <tr class="odd">
                                <td :colSpan="12" class="dataTables_empty">
                                  {{ "Sem registros" }}
                                </td>
                              </tr>
                            </template>
                          </tbody>
                          <div
                            v-if="loadingExportacao"
                            class="overlay-layer card-rounded bg-dark bg-opacity-5"
                          >
                            <div
                              class="spinner-border text-primary"
                              role="status"
                            ></div>
                            <span class="ms-2">Aguarde, carregando...</span>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade tab-pane-faturamento-prod"
                id="kt_faturamento_nfe_produtos_pedido_compra"
                role="tab-panel"
              >
                <div class="d-flex flex-column gap-7 gap-lg-10 mb-5 mx-5">
                  <div class="card card-bordered">
                    <div class="card-header bg-light min-h-50px">
                      <div class="card-title">
                        <h3>Pedido de Compra</h3>
                      </div>
                      <div class="card-toolbar">
                        <div
                          class="d-flex justify-content-end"
                          data-kt-customer-table-toolbar="base"
                        >
                          <button
                            @click="adicionarFaturamentoPedidoCompra()"
                            type="button"
                            class="btn btn-sm btn-primary btn-active-primary"
                          >
                            <span class="svg-icon svg-icon-1">
                              <inline-svg
                                src="media/icons/duotune/arrows/arr075.svg" /></span
                            >Adicionar
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-2 pb-2">
                      <div class="table-responsive">
                        <table
                          :class="[
                            loadingPedidoCompra && 'overlay overlay-block',
                          ]"
                          class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                          id="kt_table_pedido_compra"
                        >
                          <thead>
                            <tr class="fw-bolder text-muted">
                              <th>Nº Pedido Compra</th>
                              <th>Item do Ped. Compra</th>
                              <th class="min-w-100px text-end">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-if="
                                this.nfe.FaturamentoItemNFe.pedido_compra
                                  .length > 0
                              "
                            >
                              <template
                                v-for="(ped, i) in this.nfe.FaturamentoItemNFe
                                  .pedido_compra"
                                :key="i"
                              >
                                <tr>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ ped.xPed }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ ped.nItemPed }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    class="d-flex justify-content-end flex-shrink-0"
                                  >
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                      @click="editarFaturamentoPedidoCompra(i)"
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/art/art005.svg"
                                        />
                                      </span>
                                    </button>
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                      @click="removerFaturamentoPedidoCompra(i)"
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/general/gen027.svg"
                                        />
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              </template>
                            </template>
                            <template v-else>
                              <tr class="odd">
                                <td :colSpan="12" class="dataTables_empty">
                                  {{ "Sem registros" }}
                                </td>
                              </tr>
                            </template>
                          </tbody>
                          <div
                            v-if="loadingPedidoCompra"
                            class="overlay-layer card-rounded bg-dark bg-opacity-5"
                          >
                            <div
                              class="spinner-border text-primary"
                              role="status"
                            ></div>
                            <span class="ms-2">Aguarde, carregando...</span>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade tab-pane-faturamento-prod"
                id="kt_faturamento_nfe_produtos_veiculo"
                role="tab-panel"
              >
                <div class="d-flex flex-column gap-7 gap-lg-10 mb-5 mx-5">
                  <div class="card card-bordered">
                    <div class="card-header bg-light min-h-50px">
                      <div class="card-title">
                        <h3>Veículo</h3>
                      </div>
                      <div class="card-toolbar">
                        <div
                          class="d-flex justify-content-end"
                          data-kt-customer-table-toolbar="base"
                        >
                          <button
                            @click="adicionarFaturamentoVeiculo()"
                            type="button"
                            class="btn btn-sm btn-primary btn-active-primary"
                          >
                            <span class="svg-icon svg-icon-1">
                              <inline-svg
                                src="media/icons/duotune/arrows/arr075.svg" /></span
                            >Adicionar
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-2 pb-2">
                      <div class="table-responsive">
                        <table
                          :class="[loadingVeiculo && 'overlay overlay-block']"
                          class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                          id="kt_table_veiculo"
                        >
                          <thead>
                            <tr class="fw-bolder text-muted">
                              <th>Chassi</th>
                              <th>Cor</th>
                              <th>Descrição</th>
                              <th>Potência Motor (CV)</th>
                              <th class="min-w-100px text-end">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-if="
                                this.nfe.FaturamentoItemNFe.veiculo.length > 0
                              "
                            >
                              <template
                                v-for="(veic, i) in this.nfe.FaturamentoItemNFe
                                  .veiculo"
                                :key="i"
                              >
                                <tr>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ veic.chassi }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ veic.cCor }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ veic.xCor }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ veic.pot }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    class="d-flex justify-content-end flex-shrink-0"
                                  >
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                      @click="editarFaturamentoVeiculo(i)"
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/art/art005.svg"
                                        />
                                      </span>
                                    </button>
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                      @click="removerFaturamentoVeiculo(i)"
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/general/gen027.svg"
                                        />
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              </template>
                            </template>
                            <template v-else>
                              <tr class="odd">
                                <td :colSpan="12" class="dataTables_empty">
                                  {{ "Sem registros" }}
                                </td>
                              </tr>
                            </template>
                          </tbody>
                          <div
                            v-if="loadingVeiculo"
                            class="overlay-layer card-rounded bg-dark bg-opacity-5"
                          >
                            <div
                              class="spinner-border text-primary"
                              role="status"
                            ></div>
                            <span class="ms-2">Aguarde, carregando...</span>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade tab-pane-faturamento-prod"
                id="kt_faturamento_nfe_produtos_medicamento"
                role="tab-panel"
              >
                <div class="d-flex flex-column gap-7 gap-lg-10 mb-5 mx-5">
                  <div class="card card-bordered">
                    <div class="card-header bg-light min-h-50px">
                      <div class="card-title">
                        <h3>Medicamentos</h3>
                      </div>
                      <div class="card-toolbar">
                        <div
                          class="d-flex justify-content-end"
                          data-kt-customer-table-toolbar="base"
                        >
                          <button
                            @click="adicionarFaturamentoMedicamentos()"
                            type="button"
                            class="btn btn-sm btn-primary btn-active-primary"
                          >
                            <span class="svg-icon svg-icon-1">
                              <inline-svg
                                src="media/icons/duotune/arrows/arr075.svg" /></span
                            >Adicionar
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-2 pb-2">
                      <div class="table-responsive">
                        <table
                          :class="[
                            loadingMedicamentos && 'overlay overlay-block',
                          ]"
                          class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                          id="kt_table_medicamentos"
                        >
                          <thead>
                            <tr class="fw-bolder text-muted">
                              <th>Item</th>
                              <th>Nº Lote</th>
                              <th>Quantidade</th>
                              <th>Fabricação</th>
                              <th>Validade</th>
                              <th>Preço Máximo</th>
                              <th class="min-w-100px text-end">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-if="
                                this.nfe.FaturamentoItemNFe.medicamentos
                                  .length > 0
                              "
                            >
                              <template
                                v-for="(med, i) in this.nfe.FaturamentoItemNFe
                                  .medicamentos"
                                :key="i"
                              >
                                <tr>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ i + 1 }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ med.nLote }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarNumeroCasas(
                                              med.qLote,
                                              3
                                            )
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarData(med.dFab)
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarData(med.dVal)
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarNumeroCasas(
                                              med.vPMC,
                                              2
                                            )
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    class="d-flex justify-content-end flex-shrink-0"
                                  >
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                      @click="editarFaturamentoMedicamentos(i)"
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/art/art005.svg"
                                        />
                                      </span>
                                    </button>
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                      @click="removerFaturamentoMedicamentos(i)"
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/general/gen027.svg"
                                        />
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              </template>
                            </template>
                            <template v-else>
                              <tr class="odd">
                                <td :colSpan="12" class="dataTables_empty">
                                  {{ "Sem registros" }}
                                </td>
                              </tr>
                            </template>
                          </tbody>
                          <div
                            v-if="loadingMedicamentos"
                            class="overlay-layer card-rounded bg-dark bg-opacity-5"
                          >
                            <div
                              class="spinner-border text-primary"
                              role="status"
                            ></div>
                            <span class="ms-2">Aguarde, carregando...</span>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade tab-pane-faturamento-prod"
                id="kt_faturamento_nfe_produtos_combustivel"
                role="tab-panel"
              >
                <div class="d-flex flex-column gap-7 gap-lg-10 mb-5 mx-5">
                  <div class="card card-bordered">
                    <div class="card-header bg-light min-h-50px">
                      <div class="card-title">
                        <h3>Combustível</h3>
                      </div>
                      <div class="card-toolbar">
                        <div
                          class="d-flex justify-content-end"
                          data-kt-customer-table-toolbar="base"
                        >
                          <button
                            @click="adicionarFaturamentoCombustivel()"
                            type="button"
                            class="btn btn-sm btn-primary btn-active-primary"
                          >
                            <span class="svg-icon svg-icon-1">
                              <inline-svg
                                src="media/icons/duotune/arrows/arr075.svg" /></span
                            >Adicionar
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-2 pb-2">
                      <div class="table-responsive">
                        <table
                          :class="[
                            loadingCombustivel && 'overlay overlay-block',
                          ]"
                          class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                          id="kt_table_combustivel"
                        >
                          <thead>
                            <tr class="fw-bolder text-muted">
                              <th>Código ANP</th>
                              <th>Percentual Gás Natural</th>
                              <th>CODIF</th>
                              <th>Qtd</th>
                              <th>UF</th>
                              <th class="min-w-100px text-end">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-if="
                                this.nfe.FaturamentoItemNFe.combustivel.length >
                                0
                              "
                            >
                              <template
                                v-for="(comb, i) in this.nfe.FaturamentoItemNFe
                                  .combustivel"
                                :key="i"
                              >
                                <tr>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ comb.cProdANP }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarNumeroCasas(
                                              comb.pMixGN,
                                              4
                                            )
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ comb.CODIF }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{
                                            this.$utils.formatarNumeroCasas(
                                              comb.qTemp,
                                              4
                                            )
                                          }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="align-middle">
                                      <div>
                                        <span
                                          class="text-dark text-hover-primary mb-1"
                                        >
                                          {{ comb.UFCons }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    class="d-flex justify-content-end flex-shrink-0"
                                  >
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                      @click="editarFaturamentoCombustivel(i)"
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/art/art005.svg"
                                        />
                                      </span>
                                    </button>
                                    <button
                                      class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                      @click="removerFaturamentoCombustivel(i)"
                                    >
                                      <span class="svg-icon svg-icon-5 m-0">
                                        <inline-svg
                                          src="media/icons/duotune/general/gen027.svg"
                                        />
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              </template>
                            </template>
                            <template v-else>
                              <tr class="odd">
                                <td :colSpan="12" class="dataTables_empty">
                                  {{ "Sem registros" }}
                                </td>
                              </tr>
                            </template>
                          </tbody>
                          <div
                            v-if="loadingCombustivel"
                            class="overlay-layer card-rounded bg-dark bg-opacity-5"
                          >
                            <div
                              class="spinner-border text-primary"
                              role="status"
                            ></div>
                            <span class="ms-2">Aguarde, carregando...</span>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <TabelaEstadosModal
    v-if="exibirTabelaEstados"
    @exibirModalTabelaEstados="modalTabelaEstados"
    @selecionarTabelaEstado="selecionarTabelaEstado"
  ></TabelaEstadosModal>
  <FaturamentoEditarUnidTributavel
    v-if="exibirFaturamentoEditarUnidadeTributavel"
    :index="indexFaturamentoUnidadeTributavel"
    :refUndTribFaturamento="this.unidadeTributavelAtual"
    @exibirModalEditarUnidadeTributavel="
      modalFaturamentoEditarUnidadeTributavel
    "
    @adicionarUnidadeTributavel="adicionarUnidadeTributavel"
    @editarUnidadeTributavel="editarUnidadeTributavel"
  ></FaturamentoEditarUnidTributavel>
  <FaturamentoEditarImpostoImportacao
    v-if="exibirFaturamentoEditarImpostoImportacao"
    :index="indexFaturamentoImpostoImportacao"
    :refIIFaturamento="this.impostoImportacaoAtual"
    @exibirModalEditarImpostoImportacao="
      modalFaturamentoEditarImpostoImportacao
    "
    @adicionarImpostoImportacao="adicionarImpostoImportacao"
    @editarImpostoImportacao="editarImpostoImportacao"
  ></FaturamentoEditarImpostoImportacao>
  <FaturamentoEditarDeclaracaoImportacao
    v-if="exibirFaturamentoEditarDeclaracaoImportacao"
    :index="indexFaturamentoDeclaracaoImportacao"
    :refDIFaturamento="this.declaracaoImportacaoAtual"
    @exibirModalEditarDeclaracaoImportacao="
      modalFaturamentoEditarDeclaracaoImportacao
    "
    @adicionarDeclaracaoImportacao="adicionarDeclaracaoImportacao"
    @editarDeclaracaoImportacao="editarDeclaracaoImportacao"
  ></FaturamentoEditarDeclaracaoImportacao>
  <FaturamentoEditarExportacaoProduto
    v-if="exibirFaturamentoEditarExportacao"
    :index="indexFaturamentoExportacao"
    :refExpFaturamento="this.exportacaoAtual"
    @exibirModalEditarExportacao="modalFaturamentoEditarExportacao"
    @adicionarExportacao="adicionarExportacao"
    @editarExportacao="editarExportacao"
  ></FaturamentoEditarExportacaoProduto>
  <FaturamentoEditarPedidoCompra
    v-if="exibirFaturamentoEditarPedidoCompra"
    :index="indexFaturamentoPedidoCompra"
    :refPedFaturamento="this.pedidoCompraAtual"
    @exibirModalEditarPedidoCompra="modalFaturamentoEditarPedidoCompra"
    @adicionarPedidoCompra="adicionarPedidoCompra"
    @editarPedidoCompra="editarPedidoCompra"
  ></FaturamentoEditarPedidoCompra>
  <FaturamentoEditarVeiculo
    v-if="exibirFaturamentoEditarVeiculo"
    :index="indexFaturamentoVeiculo"
    :refVeicFaturamento="this.veiculoAtual"
    @exibirModalEditarVeiculo="modalFaturamentoEditarVeiculo"
    @adicionarVeiculo="adicionarVeiculo"
    @editarVeiculo="editarVeiculo"
  ></FaturamentoEditarVeiculo>
  <FaturamentoEditarFCI
    v-if="exibirFaturamentoEditarFCI"
    :index="indexFaturamentoFCI"
    :refFCIFaturamento="this.fciAtual"
    @exibirModalEditarFCI="modalFaturamentoEditarFCI"
    @adicionarFCI="adicionarFCI"
    @editarFCI="editarFCI"
  ></FaturamentoEditarFCI>
  <FaturamentoEditarMedicamento
    v-if="exibirFaturamentoEditarMedicamento"
    :index="indexFaturamentoMedicamento"
    :refMedFaturamento="this.medAtual"
    @exibirModalEditarMedicamento="modalFaturamentoEditarMedicamento"
    @adicionarMedicamento="adicionarMedicamento"
    @editarMedicamento="editarMedicamento"
  ></FaturamentoEditarMedicamento>
  <FaturamentoEditarCombustivel
    v-if="exibirFaturamentoEditarCombustivel"
    :index="indexFaturamentoCombustivel"
    :refCombFaturamento="this.combAtual"
    @exibirModalEditarCombustivel="modalFaturamentoEditarCombustivel"
    @adicionarCombustivel="adicionarCombustivel"
    @editarCombustivel="editarCombustivel"
  ></FaturamentoEditarCombustivel>
</template>

<script>
import { useToast } from "vue-toastification";
import { MenuComponent } from "@/assets/ts/components";
import { getOrCreateInstanceModal } from "@/core/helpers/dom";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import CurrencyInput from "@/components/text/CurrencyInput";
import TabelaEstadosModal from "@/views/produtos/TabelaEstadosModal.vue";
import FaturamentoEditarUnidTributavel from "@/views/faturamento/FaturamentoEditarUnidTributavel.vue";
import FaturamentoEditarImpostoImportacao from "@/views/faturamento/FaturamentoEditarImpostoImportacao.vue";
import FaturamentoEditarDeclaracaoImportacao from "@/views/faturamento/FaturamentoEditarDeclaracaoImportacao.vue";
import FaturamentoEditarExportacaoProduto from "@/views/faturamento/FaturamentoEditarExportacaoProduto.vue";
import FaturamentoEditarPedidoCompra from "@/views/faturamento/FaturamentoEditarPedidoCompra.vue";
import FaturamentoEditarVeiculo from "@/views/faturamento/FaturamentoEditarVeiculo.vue";
import FaturamentoEditarFCI from "@/views/faturamento/FaturamentoEditarFCI.vue";
import FaturamentoEditarMedicamento from "@/views/faturamento/FaturamentoEditarMedicamento.vue";
import FaturamentoEditarCombustivel from "@/views/faturamento/FaturamentoEditarCombustivel.vue";

const toast = useToast();

const nfeInicializado = {
  FaturamentoItemNFe: {
    id_estoque_st: null,
    EstoqueSt: {},
    utiliza_pis_cofins: false,
    pis_st: "49",
    pis_base: 0,
    pis_aliquota: 0,
    cofins_st: "49",
    cofins_base: 0,
    cofins_aliquota: 0,
    cst_ipi: "50",
    ipi_devolvido: 0,
    icms_desonerado: 0,
    tipo_desoneracao: "9",
    aliquota_fcp: 0,
    aliquota_fcp_st: 0,
    und_trib: [],
    imposto_importacao: [],
    declaracao_importacao: [],
    fci: [],
    det_export: [],
    pedido_compra: [],
    veiculo: [],
    medicamentos: [],
    combustivel: [],
  },
};

export default {
  components: {
    CurrencyInput,
    TabelaEstadosModal,
    FaturamentoEditarUnidTributavel,
    FaturamentoEditarImpostoImportacao,
    FaturamentoEditarDeclaracaoImportacao,
    FaturamentoEditarExportacaoProduto,
    FaturamentoEditarPedidoCompra,
    FaturamentoEditarVeiculo,
    FaturamentoEditarFCI,
    FaturamentoEditarMedicamento,
    FaturamentoEditarCombustivel,
  },
  emits: ["exibirModalEditarNFeProduto", "editarNFeProduto"],
  props: {
    index: { type: Number, required: true, default: -1 },
    refProduto: { type: Object, required: true, default: null },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = {};
      this.loading = true;

      if (this.validar() === true) {
        this.nfe.FaturamentoItemNFe.utiliza_pis_cofins =
          this.$utils.checkToString(
            this.nfe.FaturamentoItemNFe.utiliza_pis_cofins
          );
        console.log(this.nfe);
        this.$emit("editarNFeProduto", this.nfe, this.index);
        hideModal(this.$refs.kt_modal_faturamento_editar_nfe_produto);
        this.$emit("exibirModalEditarNFeProduto", false);
      } else {
        await this.$swal.showInvalidAlert("Verifique os avisos!");
      }

      this.loading = false;
    },
    validar() {
      let result = true;
      return result;
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_faturamento_editar_nfe_produto);
      this.$emit("exibirModalEditarNFeProduto", false);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    limparTabelaEstados() {
      this.nfe.FaturamentoItemNFe.id_estoque_st = null;
      this.nfe.FaturamentoItemNFe.EstoqueSt = {};
    },
    selecionarTabelaEstado(estoqueSt) {
      this.nfe.FaturamentoItemNFe.EstoqueSt = estoqueSt;
      this.nfe.FaturamentoItemNFe.id_estoque_st = estoqueSt.id;
      this.modalTabelaEstados(false);
    },
    modalTabelaEstados(exibir) {
      this.exibirTabelaEstados = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_tabela_estados_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarEstoqueSts");
          },
          /*close*/ () => {
            this.modalTabelaEstados(false);
          }
        );
      }
    },
    modalFaturamentoEditarUnidadeTributavel(exibir) {
      this.exibirFaturamentoEditarUnidadeTributavel = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_und_tributavel",
          /*open*/ () => {
            this.$utils.requestFocus("txtUndTrib");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarUnidadeTributavel(false);
          }
        );
      }
    },
    async adicionarFaturamentoUnidadeTributavel() {
      if (this.nfe.FaturamentoItemNFe.und_trib.length < 1) {
        this.indexFaturamentoUnidadeTributavel = -1;
        this.unidadeTributavelAtual = [];
        this.modalFaturamentoEditarUnidadeTributavel(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que uma unidade tributável para o item!"
        );
      }
    },
    editarFaturamentoUnidadeTributavel(index) {
      this.exibirFaturamentoEditarUnidadeTributavel = index;
      this.indexFaturamentoUnidadeTributavel = index;
      this.unidadeTributavelAtual = this.nfe.FaturamentoItemNFe.und_trib[index];
      this.modalFaturamentoEditarUnidadeTributavel(true);
    },
    removerFaturamentoUnidadeTributavel(index) {
      this.loadingUndTrib = true;
      this.nfe.FaturamentoItemNFe.und_trib.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingUndTrib = false;
    },
    adicionarUnidadeTributavel(refUND) {
      this.nfe.FaturamentoItemNFe.und_trib.push(refUND);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Unidade adicionada com sucesso!", { timeout: 2000 });
    },
    editarUnidadeTributavel(refUND, index) {
      this.nfe.FaturamentoItemNFe.und_trib[index] = refUND;
      toast.success("Unidade atualizada com sucesso!", { timeout: 2000 });
    },
    modalFaturamentoEditarImpostoImportacao(exibir) {
      this.exibirFaturamentoEditarImpostoImportacao = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_imposto_importacao",
          /*open*/ () => {
            this.$utils.requestFocus("txtValorBase");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarImpostoImportacao(false);
          }
        );
      }
    },
    async adicionarFaturamentoImpostoImportacao() {
      if (this.nfe.FaturamentoItemNFe.imposto_importacao.length < 1) {
        this.indexFaturamentoImpostoImportacao = -1;
        this.impostoImportacaoAtual = [];
        this.modalFaturamentoEditarImpostoImportacao(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que um imposto de importação para o item!"
        );
      }
    },
    editarFaturamentoImpostoImportacao(index) {
      this.exibirFaturamentoEditarImpostoImportacao = index;
      this.indexFaturamentoImpostoImportacao = index;
      this.impostoImportacaoAtual =
        this.nfe.FaturamentoItemNFe.imposto_importacao[index];
      this.modalFaturamentoEditarImpostoImportacao(true);
    },
    removerFaturamentoImpostoImportacao(index) {
      this.loadingImpostoImportacao = true;
      this.nfe.FaturamentoItemNFe.imposto_importacao.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingImpostoImportacao = false;
    },
    adicionarImpostoImportacao(refII) {
      this.nfe.FaturamentoItemNFe.imposto_importacao.push(refII);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Imposto adicionado com sucesso!", { timeout: 2000 });
    },
    editarImpostoImportacao(refII, index) {
      this.nfe.FaturamentoItemNFe.imposto_importacao[index] = refII;
      toast.success("Imposto atualizado com sucesso!", { timeout: 2000 });
    },

    modalFaturamentoEditarDeclaracaoImportacao(exibir) {
      this.exibirFaturamentoEditarDeclaracaoImportacao = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_declaracao_importacao",
          /*open*/ () => {
            this.$utils.requestFocus("txtnDI");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarDeclaracaoImportacao(false);
          }
        );
      }
    },
    async adicionarFaturamentoDeclaracaoImportacao() {
      if (this.nfe.FaturamentoItemNFe.declaracao_importacao.length < 1) {
        this.indexFaturamentoDeclaracaoImportacao = -1;
        this.declaracaoImportacaoAtual = [];
        this.modalFaturamentoEditarDeclaracaoImportacao(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que uma declaração de importação para o item!"
        );
      }
    },
    editarFaturamentoDeclaracaoImportacao(index) {
      this.exibirFaturamentoEditarDeclaracaoImportacao = index;
      this.indexFaturamentoDeclaracaoImportacao = index;
      this.declaracaoImportacaoAtual =
        this.nfe.FaturamentoItemNFe.declaracao_importacao[index];
      this.modalFaturamentoEditarDeclaracaoImportacao(true);
    },
    removerFaturamentoDeclaracaoImportacao(index) {
      this.loadingDeclaracaoImportacao = true;
      this.nfe.FaturamentoItemNFe.declaracao_importacao.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingDeclaracaoImportacao = false;
    },
    adicionarDeclaracaoImportacao(refDI) {
      this.nfe.FaturamentoItemNFe.declaracao_importacao.push(refDI);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Declaração adicionada com sucesso!", { timeout: 2000 });
    },
    editarDeclaracaoImportacao(refDI, index) {
      this.nfe.FaturamentoItemNFe.declaracao_importacao[index] = refDI;
      toast.success("Imposto atualizado com sucesso!", { timeout: 2000 });
    },

    modalFaturamentoEditarExportacao(exibir) {
      this.exibirFaturamentoEditarExportacao = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_exportacao",
          /*open*/ () => {
            this.$utils.requestFocus("txtnDraw");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarExportacao(false);
          }
        );
      }
    },
    async adicionarFaturamentoExportacao() {
      if (this.nfe.FaturamentoItemNFe.det_export.length < 500) {
        this.indexFaturamentoExportacao = -1;
        this.exportacaoAtual = [];
        this.modalFaturamentoEditarExportacao(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que 500 registros para o item!"
        );
      }
    },
    editarFaturamentoExportacao(index) {
      this.exibirFaturamentoEditarExportacao = index;
      this.indexFaturamentoExportacao = index;
      this.exportacaoAtual = this.nfe.FaturamentoItemNFe.det_export[index];
      this.modalFaturamentoEditarExportacao(true);
    },
    removerFaturamentoExportacao(index) {
      this.loadingExportacao = true;
      this.nfe.FaturamentoItemNFe.det_export.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingExportacao = false;
    },
    adicionarExportacao(refExp) {
      this.nfe.FaturamentoItemNFe.det_export.push(refExp);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Registro adicionado com sucesso!", { timeout: 2000 });
    },
    editarExportacao(refExp, index) {
      this.nfe.FaturamentoItemNFe.det_export[index] = refExp;
      toast.success("Registro atualizado com sucesso!", { timeout: 2000 });
    },

    modalFaturamentoEditarPedidoCompra(exibir) {
      this.exibirFaturamentoEditarPedidoCompra = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_pedido_compra",
          /*open*/ () => {
            this.$utils.requestFocus("txtxPed");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarPedidoCompra(false);
          }
        );
      }
    },
    async adicionarFaturamentoPedidoCompra() {
      if (this.nfe.FaturamentoItemNFe.pedido_compra.length < 1) {
        this.indexFaturamentoPedidoCompra = -1;
        this.pedidoCompraAtual = [];
        this.modalFaturamentoEditarPedidoCompra(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que 1 registro para o item!"
        );
      }
    },
    editarFaturamentoPedidoCompra(index) {
      this.exibirFaturamentoEditarPedidoCompra = index;
      this.indexFaturamentoPedidoCompra = index;
      this.pedidoCompraAtual = this.nfe.FaturamentoItemNFe.pedido_compra[index];
      this.modalFaturamentoEditarPedidoCompra(true);
    },
    removerFaturamentoPedidoCompra(index) {
      this.loadingPedidoCompra = true;
      this.nfe.FaturamentoItemNFe.pedido_compra.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingPedidoCompra = false;
    },
    adicionarPedidoCompra(ref) {
      this.nfe.FaturamentoItemNFe.pedido_compra.push(ref);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Registro adicionado com sucesso!", { timeout: 2000 });
    },
    editarPedidoCompra(ref, index) {
      this.nfe.FaturamentoItemNFe.pedido_compra[index] = ref;
      toast.success("Registro atualizado com sucesso!", { timeout: 2000 });
    },

    modalFaturamentoEditarVeiculo(exibir) {
      this.exibirFaturamentoEditarVeiculo = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_veiculo",
          /*open*/ () => {
            this.$utils.requestFocus("txttpOP");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarVeiculo(false);
          }
        );
      }
    },
    async adicionarFaturamentoVeiculo() {
      if (this.nfe.FaturamentoItemNFe.veiculo.length < 1) {
        this.indexFaturamentoVeiculo = -1;
        this.veiculoAtual = [];
        this.modalFaturamentoEditarVeiculo(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que 1 registro para o item!"
        );
      }
    },
    editarFaturamentoVeiculo(index) {
      this.exibirFaturamentoEditarVeiculo = index;
      this.indexFaturamentoVeiculo = index;
      this.veiculoAtual = this.nfe.FaturamentoItemNFe.veiculo[index];
      this.modalFaturamentoEditarVeiculo(true);
    },
    removerFaturamentoVeiculo(index) {
      this.loadingVeiculo = true;
      this.nfe.FaturamentoItemNFe.veiculo.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingVeiculo = false;
    },
    adicionarVeiculo(ref) {
      this.nfe.FaturamentoItemNFe.veiculo.push(ref);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Registro adicionado com sucesso!", { timeout: 2000 });
    },
    editarVeiculo(ref, index) {
      this.nfe.FaturamentoItemNFe.veiculo[index] = ref;
      toast.success("Registro atualizado com sucesso!", { timeout: 2000 });
    },

    modalFaturamentoEditarFCI(exibir) {
      this.exibirFaturamentoEditarFCI = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_fci",
          /*open*/ () => {
            this.$utils.requestFocus("txtnFCI");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarFCI(false);
          }
        );
      }
    },
    async adicionarFaturamentoFCI() {
      if (this.nfe.FaturamentoItemNFe.fci.length < 1) {
        this.indexFaturamentoFCI = -1;
        this.fciAtual = [];
        this.modalFaturamentoEditarFCI(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que 1 registro para o item!"
        );
      }
    },
    editarFaturamentoFCI(index) {
      this.exibirFaturamentoEditarFCI = index;
      this.indexFaturamentoFCI = index;
      this.fciAtual = this.nfe.FaturamentoItemNFe.fci[index];
      this.modalFaturamentoEditarFCI(true);
    },
    removerFaturamentoFCI(index) {
      this.loadingFCI = true;
      this.nfe.FaturamentoItemNFe.fci.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingFCI = false;
    },
    adicionarFCI(ref) {
      this.nfe.FaturamentoItemNFe.fci.push(ref);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Registro adicionado com sucesso!", { timeout: 2000 });
    },
    editarFCI(ref, index) {
      this.nfe.FaturamentoItemNFe.fci[index] = ref;
      toast.success("Registro atualizado com sucesso!", { timeout: 2000 });
    },

    modalFaturamentoEditarMedicamento(exibir) {
      this.exibirFaturamentoEditarMedicamento = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_medicamento",
          /*open*/ () => {
            this.$utils.requestFocus("txtnLote");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarMedicamento(false);
          }
        );
      }
    },
    async adicionarFaturamentoMedicamentos() {
      if (this.nfe.FaturamentoItemNFe.medicamentos.length < 500) {
        this.indexFaturamentoMedicamento = -1;
        this.medicamentoAtual = [];
        this.modalFaturamentoEditarMedicamento(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que 500 registros para o item!"
        );
      }
    },
    editarFaturamentoMedicamentos(index) {
      this.exibirFaturamentoEditarMedicamento = index;
      this.indexFaturamentoMedicamento = index;
      this.medAtual = this.nfe.FaturamentoItemNFe.medicamentos[index];
      this.modalFaturamentoEditarMedicamento(true);
    },
    removerFaturamentoMedicamentos(index) {
      this.loadingMedicamentos = true;
      this.nfe.FaturamentoItemNFe.medicamentos.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingMedicamentos = false;
    },
    adicionarMedicamento(ref) {
      this.nfe.FaturamentoItemNFe.medicamentos.push(ref);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Registro adicionado com sucesso!", { timeout: 2000 });
    },
    editarMedicamento(ref, index) {
      this.nfe.FaturamentoItemNFe.medicamentos[index] = ref;
      toast.success("Registro atualizado com sucesso!", { timeout: 2000 });
    },

    modalFaturamentoEditarCombustivel(exibir) {
      this.exibirFaturamentoEditarCombustivel = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_combustivel",
          /*open*/ () => {
            this.$utils.requestFocus("txtcProdANP");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarCombustivel(false);
          }
        );
      }
    },
    async adicionarFaturamentoCombustivel() {
      if (this.nfe.FaturamentoItemNFe.combustivel.length < 1) {
        this.indexFaturamentoCombustivel = -1;
        this.combustivelAtual = [];
        this.modalFaturamentoEditarCombustivel(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que 1 registro para o item!"
        );
      }
    },
    editarFaturamentoCombustivel(index) {
      this.exibirFaturamentoEditarCombustivel = index;
      this.indexFaturamentoCombustivel = index;
      this.combAtual = this.nfe.FaturamentoItemNFe.combustivel[index];
      this.modalFaturamentoEditarCombustivel(true);
    },
    removerFaturamentoCombustivel(index) {
      this.loadingCombustivel = true;
      this.nfe.FaturamentoItemNFe.combustivel.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingCombustivel = false;
    },
    adicionarCombustivel(ref) {
      this.nfe.FaturamentoItemNFe.combustivel.push(ref);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Registro adicionado com sucesso!", { timeout: 2000 });
    },
    editarCombustivel(ref, index) {
      this.nfe.FaturamentoItemNFe.combustivel[index] = ref;
      toast.success("Registro atualizado com sucesso!", { timeout: 2000 });
    },
    async retornarTabelaEstados(id) {
      try {
        let filter = "?$filter=id eq " + id;
        let retOdataEstoqueSt = await this.$store.dispatch(
          "estoqueSt/getEstoqueStOData",
          filter
        );

        if (
          retOdataEstoqueSt.value !== null &&
          retOdataEstoqueSt.value.length > 0
        ) {
          return retOdataEstoqueSt.value[0];
        }
      } catch (error) {
        console.log(error);
      }
      return null;
    },
  },
  async mounted() {
    if (
      this.refProduto &&
      this.refProduto.FaturamentoItemNFe &&
      this.refProduto.FaturamentoItemNFe.und_trib
    ) {
      let nfeIni = {
        FaturamentoItemNFe: JSON.parse(
          JSON.stringify(this.refProduto.FaturamentoItemNFe)
        ),
      };
      this.nfe = nfeIni;
      this.nfe.FaturamentoItemNFe.utiliza_pis_cofins =
        this.$utils.stringToChecked(
          this.nfe.FaturamentoItemNFe.utiliza_pis_cofins
        );

      if (
        this.nfe.FaturamentoItemNFe.id_estoque_st &&
        this.nfe.FaturamentoItemNFe.id_estoque_st !== null &&
        this.nfe.FaturamentoItemNFe.id_estoque_st > 0
      ) {
        let tabelaEstados = await this.retornarTabelaEstados(
          this.nfe.FaturamentoItemNFe.id_estoque_st
        );
        if (tabelaEstados !== null) {
          this.nfe.FaturamentoItemNFe.EstoqueSt = tabelaEstados;
        }
      }
    } else {
      this.nfe = JSON.parse(JSON.stringify(nfeInicializado));
    }
    this.produto = JSON.parse(JSON.stringify(this.refProduto));
    this.errosValidacao = {};
  },
  data() {
    return {
      exibirTabelaEstados: false,
      errosValidacao: [],
      loading: false,
      produto: {},
      loadingUndTrib: false,
      exibirFaturamentoEditarUnidadeTributavel: false,
      indexFaturamentoUnidadeTributavel: -1,
      unidadeTributavelAtual: {},
      loadingImpostoImportacao: false,
      exibirFaturamentoEditarImpostoImportacao: false,
      indexFaturamentoImpostoImportacao: -1,
      impostoImportacaoAtual: {},
      loadingDeclaracaoImportacao: false,
      exibirFaturamentoEditarDeclaracaoImportacao: false,
      indexFaturamentoDeclaracaoImportacao: -1,
      declaracaoImportacaoAtual: {},
      loadingExportacao: false,
      exibirFaturamentoEditarExportacao: false,
      indexFaturamentoExportacao: -1,
      exportacaoAtual: {},
      loadingPedidoCompra: false,
      exibirFaturamentoEditarPedidoCompra: false,
      indexFaturamentoPedidoCompra: -1,
      pedidoCompraAtual: {},
      loadingVeiculo: false,
      exibirFaturamentoEditarVeiculo: false,
      indexFaturamentoVeiculo: -1,
      veiculoAtual: {},
      loadingFCI: false,
      exibirFaturamentoEditarFCI: false,
      indexFaturamentoFCI: -1,
      fciAtual: {},
      loadingMedicamentos: false,
      exibirFaturamentoEditarMedicamento: false,
      indexFaturamentoMedicamento: -1,
      medAtual: {},
      loadingCombustivel: false,
      exibirFaturamentoEditarCombustivel: false,
      indexFaturamentoCombustivel: -1,
      combAtual: {},
      nfe: JSON.parse(JSON.stringify(nfeInicializado)),
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: false,
      },
    };
  },
};
</script>

<style></style>
